var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('p',[_vm._v("Are you sure you want to delete "+_vm._s(_vm.partnerName)+" as a partner?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }